(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('cloneProjectsService', cloneProjectsService);

	cloneProjectsService.$inject = ['$http', 'hostUrl'];

	function cloneProjectsService($http, hostUrl) {
		var service = {
			cloneProjects: cloneProjects
		};
		return service;

		function cloneProjects(source, dest, args) {
			var url = hostUrl + '2/CloneProjects/src/' + source + '/dst/' + dest;
			return $http.post(url, args)
				.then(cloneSettingsComplete)
				.catch(cloneSettingsFailed);

			function cloneSettingsComplete(response) {
				return response;
			}

			function cloneSettingsFailed(error) {
				return error;
			}
		}
	}
})();
